import nodePool from '@ps/bridge/qc/node-pool'
import { getAtlasUuid } from '@ps/bridge/qc/node'
import { getSetImageAction } from '@ps/workbench/undo-redo'
import { executeAction } from '@ps/workbench/undo-redo'
import store from '@ps/store'
import { getLayoutData, updateLayoutData } from '@ps/bridge/qc/scripts/layout'
import _ from 'lodash'
import { closePreviewAllBox2dShape } from '@ps/workbench/undo-redo/module/box2d'

/**
 * 更新节点图片资源
 * @param resourceUuid 资源id
 * @param nodeUuid 节点id
 * @param record 是否加历史记录
 * @returns {Promise<void>}
 */
export default async function (
  { state },
  {
    resourceUuid,
    nodeUuid,
    resetImageAfterAdd,
    addImageToConfig = false,
    resetAnotherLayout = false,
    record = true,
  },
) {
  const nodes = []
  if (Array.isArray(nodeUuid)) {
    nodeUuid.forEach((uuid) => {
      nodes.push(nodePool.find(uuid))
    })
  } else if (typeof nodeUuid === 'string') {
    nodes.push(nodePool.find(nodeUuid))
  }
  if (resetAnotherLayout) {
    const anotherResolution =
      store.state.workspace.game.device.anotherResolution
    nodes.forEach((node) => {
      const layoutData = getLayoutData(node, anotherResolution)
      updateLayoutData({
        node: node,
        resolution: anotherResolution,
        data: _.omit(layoutData, ['width', 'height']),
        setAndRefresh: false,
      })
    })
  }
  const newValueArray = nodes.map((node) => {
    return {
      resourceUuid,
      nodeUuid: node.uuid,
      resetImageAfterAdd,
      addImageToConfig,
    }
  })
  const oldValueArray = nodes.map((node) => {
    return {
      resourceUuid: getAtlasUuid(node),
      style: node
        ? {
            width: node.width,
            height: node.height,
          }
        : {},
      nodeUuid: node.uuid,
      resetImageAfterAdd,
      addImageToConfig,
      phaserTexture: node.phaser.texture, // 龙骨子节点时，需要加该属性，记录子节点的初始图片，用于图片替换后的撤销操作
    }
  })
  // 替换图片时关闭刚体轮廓预览
  store.commit('workspace/game/updatePreviewBox2dShapeState', {
    val: false,
  })
  store.commit('workspace/game/updatePreviewBox2dShapeAllState', {
    val: false,
  })
  closePreviewAllBox2dShape()

  await executeAction({
    action: getSetImageAction({
      newValue: newValueArray,
      oldValue: oldValueArray,
    }),
    record,
  })
}
